import { styled } from '@mui/material/styles';
import { Box, BoxProps } from 'shared/mui/Box';

export type FilterBarRowProps = BoxProps;

export const FilterBarRow = styled(Box)<FilterBarRowProps>({
  alignItems: 'start',
  display: 'grid',
  gap: '0 16px ',
  gridTemplateColumns: '3fr 1fr',
});
